module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-home panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('header', [_c('div', {
    staticClass: "flex"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "action-bar flex-none"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.searchUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "thread-controls flex"
  }, [_c('div', {
    staticClass: "flex flex-full"
  }, [_c('TabSelect', {
    attrs: {
      "options": _vm.threadSubsetOptions,
      "value": _vm.threadSubset
    },
    on: {
      "input": function($event) {
        _vm.setThreadSubset($event)
      }
    }
  }), _vm._v(" "), (_vm.threadSubset === 'top') ? _c('DropdownSelect', {
    attrs: {
      "options": _vm.threadSubsetPeriodOptions,
      "value": _vm.threadSubsetPeriod
    },
    on: {
      "input": function($event) {
        _vm.setThreadSubsetPeriod($event)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-none"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.newThreadUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n                    Create Thread\n                ")])], 1)]), _vm._v(" "), (_vm.threadSubset === 'categories') ? _c('ForumHomeCategories') : _vm._e(), _vm._v(" "), (_vm.threadSubset === 'latest') ? _c('ForumHomeLatest', {
    attrs: {
      "sort-order": _vm.threadSortOrder
    },
    on: {
      "update:sort-order": function($event) {
        _vm.threadSortOrder = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.threadSubset === 'top') ? _c('ForumHomeTop', {
    attrs: {
      "period": _vm.threadSubsetPeriod,
      "sort-order": _vm.threadSortOrder
    },
    on: {
      "update:sort-order": function($event) {
        _vm.threadSortOrder = $event
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-full"
  }, [_c('h1', [_vm._v("Forum Home")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c163be6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForumHome.vue
// module id = 2025
// module chunks = 2